import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { SITE } from "../../lib/site";
import { ButtonLink } from "../ui/Button";
import { Logo } from "../ui/Logo";

/**
 * Route-level error element (also the app-wide fallback). Friendly, links home.
 * A thrown 404 from a loader would land here too, but unmatched URLs are handled
 * by the dedicated NotFound route so they get correct SEO.
 */
export function ErrorBoundary() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : null;

  return (
    <div className="flex min-h-screen flex-col">
      <div className="border-b border-line px-5 py-4 sm:px-8">
        <Link to="/" aria-label={`${SITE.name} — home`}>
          <Logo />
        </Link>
      </div>
      <div className="mx-auto flex max-w-xl flex-1 flex-col items-center justify-center px-5 py-20 text-center">
        <p className="eyebrow">{status ? `Error ${status}` : "Something went wrong"}</p>
        <h1 className="mt-3 text-h2 font-semibold">This page hit a snag</h1>
        <p className="mt-4 text-ink-soft">
          An unexpected error interrupted the page. You can head back to the homepage and try
          again — if it keeps happening, let us know.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <ButtonLink to="/" size="lg">
            Back to homepage
          </ButtonLink>
          <ButtonLink to="/contact" variant="secondary" size="lg">
            Contact us
          </ButtonLink>
        </div>
      </div>
    </div>
  );
}
